const financialfairness = {
  '--primary': '#2B45AD',
  '--secondary': '#327BB8',
  '--tertiary': '#008077',
  '--digital-deep-grey': '#000',
  '--digital-ash-grey': '#615752',
  '--error-400': '#BE3430',
};
export default financialfairness;
